<template>
  <div>
    <router-view :key="key" />
  </div>
</template>

<script>
export default {
  name: "index1.vue",
  components: {},
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped></style>
